// extracted by mini-css-extract-plugin
module.exports = {"container":"electionRoundResult_container__xooYv"};